<template>
    <div  v-show="page.state=='rendered'" >
        <canvas :width="page.width" :height="page.height" class="pdf-page box-shadow" ref="pdfCanvas">dibuix</canvas>
    </div>
    
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  props:{
    page: {
      type: Object, // instance containing an instance of  PDFPageProxy returned from pdf.getPage
      required: true,
    },
  }, 
  data(){
      return {
          renderTask:undefined,
      }
  },
  methods:{
    async drawPage() {
      if (this.page.state === 'downloaded' )
      {
        const numPage=this.page.numPage
        const pdfPage= await this.getPDFPage(numPage)
        this.setPageValues({
            pageIndex:numPage,
            values:{state:'rendering'}
        })
        const canvasContext = this.$refs.pdfCanvas.getContext("2d");
        const renderContext = { canvasContext, viewport:pdfPage.getViewport({scale: 1.}) };

        // PDFPageProxy#render
        // https://mozilla.github.io/pdf.js/api/draft/PDFPageProxy.html
        this.renderTask=pdfPage.render(renderContext);
        await this.renderTask.promise;
        if(this.page.state=='rendering')
        {
            this.setPageValues({
                pageIndex:numPage,
                values:{state:'rendered'}
            })  
        } else {
            console.log('finished the render of a destroyed page')
        }
      }  
    },   
    ...mapActions({
      setPageValues: "pdf_data/setPageValues",
      getPDFPage: "pdf_data/getPDFPage",
      cleanPage: "pdf_data/cleanPage",
    })  
  },
  mounted(){
    this.drawPage()
  },
  updated() {
    this.drawPage()
  },
  beforeDestroy() {
    console.log("this page is destroying:"+this.page.numPage)
    // if(this.renderTask && this.renderTask.promise){
    //    console.log(this.renderTask)
    //    this.renderTask.cancel();
    //    delete this.renderTask; 
    // }
    this.cleanPage(this.page.numPage)
  },
}
</script>
<style scoped>

</style>